import { Form } from 'react-bootstrap';

/** Gift Shop FloatingInput + optional inline Send/Verify button (OTP). */
function FloatingInput({
  placeholder,
  label,
  icon: Icon,
  type,
  visiblePassword,
  setVisiblePassword,
  name,
  value,
  onChange,
  onKeyDown,
  text,
  onSend,
  sendDisabled = false,
  autoComplete,
}) {
  if (text) {
    return (
      <div className="floatingInput floatingInput--inlineEnd">
        <div className="floatingInput__row">
          <Form.Control
            id={name}
            name={name}
            value={value ?? ''}
            onChange={onChange}
            onKeyDown={onKeyDown}
            className="form-control"
            type={visiblePassword ? 'text' : type || 'text'}
            placeholder={placeholder}
            autoComplete={autoComplete}
          />
          <button
            type="button"
            className="floatingInput__endBtn floatingInput__endBtn--primary"
            onClick={onSend}
            disabled={sendDisabled}
          >
            {text}
          </button>
        </div>
        <label htmlFor={name}>{label}</label>
      </div>
    );
  }

  return (
    <div className="floatingInput">
      <Form.Control
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        className="form-control"
        type={visiblePassword ? 'text' : type}
        placeholder={placeholder}
        autoComplete={autoComplete}
      />
      <label htmlFor={name}>{label}</label>
      {Icon ? (
        type === 'password' ? (
          <span
            className={`fieldIcon ${visiblePassword ? 'active' : ''}`}
            onClick={() => setVisiblePassword(!visiblePassword)}
          >
            <Icon />
          </span>
        ) : (
          <span className="fieldIcon">
            <Icon />
          </span>
        )
      ) : null}
    </div>
  );
}

export default FloatingInput;
